import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";

const maxRetries = 2;

const baseQuery = retry(
	fetchBaseQuery({
		baseUrl: process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE,
	}),
	{ maxRetries }
);

export const bankAPI = createApi({
	reducerPath: "bankAPI",
	baseQuery,
	keepUnusedDataFor: 0,
	tagTypes: ["tagGetBank", "tagGetBanks", "tagPostBank", "tagPutBank", "tagDeleteBank", "tagGetBanksLight"],
	refetchOnMountOrArgChange: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		//* *********************************************************** */
		//* GET BANK */
		getBank: builder.query({
			query: (body: any) => ({
				url: `/banks/${body.bankId}`,
				headers: { authorization: body.token },
			}),
			providesTags: ["tagGetBank"],
		}),
		//* *********************************************************** */
		//* GET ALL BANKS */
		getBanks: builder.query({
			query: (body: any) => ({
				url: `/banks/?&page=${body.page}&limit=${body.limit}${body.searchAndFilterString || ""}`,
				headers: { authorization: body.token },
			}),
			providesTags: ["tagGetBanks"],
		}),
		//* *********************************************************** */
		//* GET ALL BANKS LIGHT */
		getBanksLight: builder.query({
			query: (body: any) => ({
				url: `/banks/light/${body.orgId}`,
				headers: { authorization: body.token },
			}),
			providesTags: ["tagGetBanksLight"],
		}),
		//* *********************************************************** */
		//* GET ALL ORGANIZATION BANKS */
		getBanksByOrganization: builder.query({
			query: (body: any) => ({
				url: `/banks/org/?&page=${body.page}&limit=${body.limit}${body.searchAndFilterString || ""}`,
				headers: { authorization: body.token },
			}),
			providesTags: ["tagGetBanks"],
		}),
		//* *********************************************************** */
		//* GET BANKS BY SERVER */
		getBanksByServer: builder.query({
			query: (body: any) => ({
				url: `/banks/byServer/${body.idServer}?&page=${body.page}&limit=${body.limit}${
					body.searchAndFilterString || ""
				}`,
				headers: { authorization: body.token },
			}),
			providesTags: ["tagGetBanks"],
		}),
		//* *********************************************************** */
		//* CREATE BANK */
		postBank: builder.mutation({
			query: (body: any) => ({
				url: "/banks/",
				method: "post",
				body: body.body,
				headers: { authorization: body.token },
			}),
			invalidatesTags: ["tagGetBanks"],
		}),
		//* *********************************************************** */
		//* CREATE BANK ACTION */
		putBankAction: builder.mutation({
			query: (body: any) => ({
				url: `/banks/actions/${body.id}`,
				method: "put",
				body: body.body,
				headers: { authorization: body.token },
			}),
			invalidatesTags: ["tagGetBanks", "tagGetBank"],
		}),
		//* *********************************************************** */
		//* PUT BANK */
		putBank: builder.mutation({
			query: (body: any) => ({
				url: `/banks/${body.id}`,
				method: "put",
				body: body.body,
				headers: { authorization: body.token },
			}),
			invalidatesTags: ["tagGetBanks", "tagGetBank"],
		}),
		//* *********************************************************** */
		//* DELETE BANK */
		deleteBank: builder.mutation({
			query: (body: any) => ({
				url: `/banks/${body.id}`,
				method: "delete",
				headers: { authorization: body.token },
			}),
			invalidatesTags: ["tagGetBanks"],
		}),
		//* *********************************************************** */
	}),
});

export const {
	useLazyGetBankQuery,
	useGetBankQuery,
	useLazyGetBanksQuery,
	useGetBanksLightQuery,
	useLazyGetBanksByServerQuery,
	useLazyGetBanksByOrganizationQuery,
	usePostBankMutation,
	usePutBankMutation,
	useDeleteBankMutation,
	usePutBankActionMutation,
} = bankAPI;
